import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

function RedirectPage() {
  const { shortCode } = useParams();

  useEffect(() => {
    // Direct navigation to backend endpoint - no API call needed
    // Backend /api/r/:code handles scan logging and redirect in one go
    window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/r/${shortCode}`);
  }, [shortCode]);

  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      <p style={{ marginTop: '1rem', color: 'var(--text-secondary)' }}>Redirecting...</p>
    </div>
  );
}

export default RedirectPage;
